import { type InternalBladeDesignKey } from 'horizon/components/Images/ImageViewer/ImageViewerTabs/SchematicView/InternalBladeSlicedView';
import { type AtlasGqlBladeMakeModel } from 'types/atlas-graphql';

export const hasSingleValidBladeMakeModel = (
  makeModels: AtlasGqlBladeMakeModel[] | null | undefined
) => makeModels?.length === 1 && makeModels[0].make && makeModels[0].model && makeModels[0].length;

export const WEB_MODEL_MAP: Record<number, InternalBladeDesignKey> = {
  1: 'single-web',
  2: 'two-web',
  3: 'three-web',
  4: 'four-web',
};
